"use strict";
const _ = require('lodash');
function roundDown(value, precision = 2) {
    const factor = 10 ** precision;
    const roundedValue = Math.floor(value * factor) / factor;
    // This must be done since 0.57-0.01 = 0.5599999999999999 (and other similiar cases)
    const epsilon = 1e-10; // Small tolerance to detect floating-point precision issues
    if (Math.abs(value - roundedValue - 1 / factor) < epsilon) {
        return _.round(value, precision);
    }
    return roundedValue;
}
module.exports = { roundDown };
